import {User} from './user';
import {Vehicle} from './vehicle';
import {TravelStatus} from './travel-status';
import {Admin} from './admin';

export class Travel {
	public id: number;
	public vehicle: Vehicle;
	public user: User;
  public admin: Admin
	public start_kilometers: string;
	public end_kilometers: string;
	public fuel_level: number;
	public motivation: number;
	public motivation_name: string;
	public motivation_other: string;
	public other_drivers: string; // QUESTO CAMPO E DEPRICATO; STA SEMPRE NEL DB PERO NON VENGA MAI USATO PIU
	public passengers: string;
	public reporting: string;
	public first_reporting: string;
	public route: string;
	public route_modified: boolean;
	public trv_prk_name: string;

	public start_latitude: string;
	public start_longitude: string;
	public start_altitude: string;

	public end_latitude: string;
	public end_longitude: string;
	public end_altitude: string;

	public is_expanded: boolean;
	public status: TravelStatus;
	public refills_counted: number;
	public prefix: string;
	public assigned_at: Date;
	public started_at: Date;
	public started_at_app: Date;
	public ended_at: Date;
	public handled_at: Date;
	public closed_at: Date;
	public created_at: Date;
	public required_from: Date;
	public required_to: Date;

	public motivationExpanded = false;
	public o_driversExpanded = false;
	public reportingExpanded = false;

	public type: number; // 0 for users | 1 for administrator

	constructor(server_obj) {
		this.prefix = 'trv_';
		this.is_expanded = false;
		if (server_obj) {
			this.id = Number(server_obj[this.prefix + 'id']);

			this.user = new User(server_obj);
			this.vehicle = new Vehicle(server_obj);
      this.admin = new Admin(server_obj);
			this.status = new TravelStatus(server_obj);
			this.start_kilometers = server_obj[this.prefix + 'start_kilometers'];
			this.end_kilometers = server_obj[this.prefix + 'end_kilometers'];
			this.fuel_level = server_obj[this.prefix + 'fuel_level'];
			this.motivation = server_obj[this.prefix + 'motivation'];
			this.motivation_name = server_obj[this.prefix + 'motivation_name'];
			this.motivation_other = server_obj[this.prefix + 'motivation_other'];
			this.other_drivers = server_obj[this.prefix + 'other_drivers'];
			this.passengers = server_obj[this.prefix + 'passengers'];
			this.refills_counted = server_obj['refills_counted'];
			this.reporting = server_obj[this.prefix + 'reporting'];
			this.first_reporting = server_obj[this.prefix + 'first_reporting'];
			this.route = server_obj[this.prefix + 'route'];
			this.route_modified = server_obj[this.prefix + 'route_modified'];
			this.trv_prk_name = server_obj['trv_prk_name'];

			this.start_latitude = server_obj[this.prefix + 'start_latitude'];
			this.start_longitude = server_obj[this.prefix + 'start_longitude'];
			this.start_altitude = server_obj[this.prefix + 'start_atitude'];

			this.end_latitude = server_obj[this.prefix + 'end_latitude'];
			this.end_longitude = server_obj[this.prefix + 'end_longitude'];
			this.end_altitude = server_obj[this.prefix + 'end_atitude'];

			this.type = server_obj[this.prefix + 'type'];

			if (server_obj[this.prefix + 'started_at']) {
				this.started_at = new Date(server_obj[this.prefix + 'started_at'].replace(/-/g, '/'));
			} else {
				this.started_at = null;
			}

			if (server_obj[this.prefix + 'ended_at']) {
				this.ended_at = new Date(server_obj[this.prefix + 'ended_at'].replace(/-/g, '/'));
			} else {
				this.ended_at = null;
			}

			if (server_obj[this.prefix + 'assigned_at']) {
				this.assigned_at = new Date(server_obj[this.prefix + 'assigned_at'].replace(/-/g, '/'));
			} else {
				this.assigned_at = null;
			}

			if (server_obj[this.prefix + 'handled_at']) {
				this.handled_at = new Date(server_obj[this.prefix + 'handled_at']);
			} else {
				this.handled_at = null;
			}

			if (server_obj[this.prefix + 'closed_at']) {
				this.closed_at = new Date(server_obj[this.prefix + 'closed_at'].replace(/-/g, '/'));
			} else {
				this.closed_at = null;
			}

			if (server_obj[this.prefix + 'created_at']) {
				this.created_at = new Date(server_obj[this.prefix + 'created_at'].replace(/-/g, '/'));
			} else {
				this.created_at = null;
			}

			if (server_obj[this.prefix + 'required_from']) {
				this.required_from = new Date(server_obj[this.prefix + 'required_from'].replace(/-/g, '/'));
			} else {
				this.required_from = null;
			}

			if (server_obj[this.prefix + 'required_to']) {
				this.required_to = new Date(server_obj[this.prefix + 'required_to'].replace(/-/g, '/'));
			} else {
				this.required_to = null;
			}


		} else {
			this.id = -1;
			this.motivation = -1;
			this.motivation_name = '';
			this.motivation_other = '';
			this.other_drivers = '';
			this.passengers = '';
			this.user = new User(undefined);
			this.vehicle = new Vehicle(undefined);
      this.admin = new Admin(undefined);
			this.status = new TravelStatus(undefined);
		}
	}

	travelRequested() {
		return !!this.id && this.id > 0;
	}

	travelStarted() {
		return this.travelApproved() && !!this.started_at;
	}

	travelEnded() {
		return this.travelStarted() && !!this.ended_at;
	}

	travelPending() {
		return this.status.id === 1;
	}

	travelApproved() {
		return this.status.id === 3;
	}

	travelRefuesed() {
		return this.status.id === 2;
	}

	travelHandled() {
		return !!this.handled_at;
	}
}
